import { NURSE_COPY } from './nurseCopy';

/** Compteurs file infirmerie — chaque tuile ouvre le filtre correspondant. */
export function getNurseQueueStatTiles(copy = NURSE_COPY) {
  const D = copy.DASHBOARD;
  return [
  {
    id: 'pending',
    filterId: 'pending',
    title: D.STAT_PENDING,
    hint: D.STAT_PENDING_HINT,
    icon: 'inbox',
    tone: 'amber'
  },
  {
    id: 'care',
    filterId: 'care',
    title: D.STAT_CARE,
    hint: D.STAT_CARE_HINT,
    icon: 'heart',
    tone: 'teal'
  },
  {
    id: 'exam',
    filterId: 'exam',
    title: D.STAT_EXAM,
    hint: D.STAT_EXAM_HINT,
    icon: 'stethoscope',
    tone: 'emerald'
  },
  {
    id: 'done',
    filterId: 'done',
    title: D.STAT_DONE,
    hint: D.STAT_DONE_HINT,
    icon: 'checkCircle',
    tone: 'slate'
  }
  ];
}

export const NURSE_QUEUE_STAT_TILES = getNurseQueueStatTiles();

/** Raccourcis navigation — actions réellement utiles au poste infirmier. */
export function getNurseQuickAccessItems({ showLocalPharmacy = false, copy = NURSE_COPY } = {}) {
  const D = copy.DASHBOARD;
  return [
    {
      id: 'accueil',
      pathKey: 'ACCUEIL_ADHERENT',
      icon: 'users',
      title: D.QUICK_ACCUEIL.TITLE,
      hint: D.QUICK_ACCUEIL.HINT
    },
    {
      id: 'file',
      pathKey: 'FILE',
      icon: 'inbox',
      title: D.QUICK_FILE.TITLE,
      hint: D.QUICK_FILE.HINT,
      accent: true
    },
    {
      id: 'history',
      pathKey: 'HISTORIQUE_PASSAGES',
      icon: 'history',
      title: D.QUICK_HISTORY.TITLE,
      hint: D.QUICK_HISTORY.HINT
    },
    showLocalPharmacy
      ? {
          id: 'pharmacy',
          pathKey: 'PHARMACY_LOCAL',
          icon: 'pills',
          title: D.QUICK_PHARMACY.TITLE,
          hint: D.QUICK_PHARMACY.HINT
        }
      : null,
    {
      id: 'guide',
      pathKey: 'GUIDE',
      icon: 'question',
      title: D.QUICK_GUIDE.TITLE,
      hint: D.QUICK_GUIDE.HINT
    }
  ].filter(Boolean);
}
